<template>
  <div class="laypanel" style="margin-left: 40px;margin-right: 40px;">
    <el-tabs  style="height: 200px;">
      <el-tab-pane label="轮播配置">
        <el-row class="querypanel">
          <el-col :span="8"><div>
            <el-select v-model="brandpos" filterable placeholder="请选择轮播图位置">
              <el-option
                v-for="item in brandposlist"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div></el-col>
          <el-col :span="12">
            <el-button  @click="addbrand">添加轮播图</el-button>
            <el-button @click="querybrand">查询轮播图</el-button>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            stripe
            :data="branddata"
            ref="multipleTable">
            <el-table-column
              prop="tjindex"
              label="显示次序">
            </el-table-column>
            <el-table-column
              prop="adurl.String"
              label="图片地址">
            </el-table-column>
            <el-table-column
              label="轮播图图片">
              <template slot-scope="scope">
                <div v-if="scope.row.adurl.Valid">
                  <img :src="scope.row.adurl.String" class="avatarimg2">
                </div>
                <div v-else>
                  {scope.row.imgurl.String}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="80px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑该轮播图" placement="top-start">
                  <i class="fa fa-eye fa-lg opicon curpointer" v-on:click="editlbt(scope.$index, branddata)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除该轮播图" placement="top-start">
                  <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="dellbt(scope.$index, branddata)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-dialog title="资料信息" :visible.sync="vis_addbrandpanel">
          <div >
            <el-form  label-width="120px">
            <el-row >
              <el-col :span="24">
                  <el-form-item label="轮播图位置：">
                    <el-select v-model="brandpos" filterable placeholder="请选择轮播图位置">
                      <el-option
                        v-for="item in brandposlist"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
              <el-row >
                <el-col :span="12">
                    <el-form-item label="上传轮播图：" class="yyzz_upload">
                      <el-upload
                        class="avatar-uploader"
                        drag
                        action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                        :data="uplbtparams"
                        multiple
                        :on-success="OnLCLBTResourceSuccess"
                        :on-error="OnLCLBTResourceError"
                        :before-upload="BeforeLCLBTResourceUpload">
                      </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-collapse v-model="scactive" accordion>
                    <el-collapse-item title="上传说明" name="1">
                      <div>1、您可以上传任何类型的资料。</div>
                      <div>2、上传前一定要看好上传的路径！</div>
                      <div>3、上传时，上传文件下方会有上传进度。</div>
                    </el-collapse-item>
                  </el-collapse>
                </el-col>
                <el-col>
                  <el-form-item label="轮播图地址：" class="yyzz_upload">
                    <el-input v-model="address_lbt" placeholder="视频地址"></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="显示次序：" class="yyzz_upload">
                    <el-input v-model="lbttjindex" placeholder="显示次序"></el-input>
                  </el-form-item>
                </el-col>
                <el-col style="margin-bottom: 2rem;margin-top: 2rem;">
                    <el-radio-group v-model="radiovalue" v-on:change="linkchange">
                      <el-radio label="1">暂无链接</el-radio>
                      <el-radio label="2">存在链接</el-radio>
                    </el-radio-group>
                </el-col>
              </el-row>
              <el-row v-if="showlbtlink">
                <el-tabs v-model="lbt_link">
                  <el-tab-pane label="视频" name="tab_video">
                    <el-row >
                      <el-col :span="12">
                          <el-form-item label="上传视频：" class="yyzz_upload">
                            <el-upload
                              class="avatar-uploader"
                              drag
                              action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                              :data="uplbtparams"
                              multiple
                              :on-success="OnVideoResourceSuccess"
                              :on-error="OnLCLBTResourceError"
                              :before-upload="BeforeLCLBTResourceUpload">
                            </el-upload>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-collapse v-model="scactive" accordion>
                          <el-collapse-item title="上传视频说明" name="1">
                            <div>1、上传完毕后，地址会自动填充到下面文本框</div>
                            <div>2、也可以通过阿里云后台直接上传到OSS对应的位置，复制地址到下面的文本框</div>
                          </el-collapse-item>
                        </el-collapse>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-form-item label="视频地址：" class="yyzz_upload">
                        <el-input v-model="address_video" placeholder="视频地址"></el-input>
                      </el-form-item>
                    </el-row>
                  </el-tab-pane>
                  <el-tab-pane label="商品分类" name="tab_goodstype">
                    <el-row >
                      <el-col :span="12">
                        <el-form-item label="上传分类内图：" class="yyzz_upload">
                          <el-upload
                            class="avatar-uploader"
                            drag
                            action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                            :data="uplbtparams"
                            multiple
                            :on-success="OnTypeNImgResourceSuccess"
                            :on-error="OnLCLBTResourceError"
                            :before-upload="BeforeLCLBTResourceUpload">
                          </el-upload>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-collapse v-model="scactive" accordion>
                          <el-collapse-item title="上传图片" name="1">
                            <div>1、上传完毕后，地址会自动填充到下面文本框</div>
                            <div>2、也可以通过阿里云后台直接上传到OSS对应的位置，复制地址到下面的文本框</div>
                          </el-collapse-item>
                        </el-collapse>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-form-item label="内页图片地址：" class="yyzz_upload">
                        <el-input v-model="address_type_img" placeholder="内页地址"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row>
                      <el-form-item label="链接产品分类:" >
                        <el-table
                          stripe
                          ref="lbtlinktype"
                          :data="goodstypedata"
                          highlight-current-row
                          @current-change="typeselectchange"
                        >
                          <el-table-column
                            prop="name.String"
                            label="分类名称">
                          </el-table-column>
                        </el-table>
                      </el-form-item>
                    </el-row>
                    <el-row>
                      <el-form-item label="当前选取分类：" class="yyzz_upload">
                        <el-input v-model="select_type" placeholder="所选分类"></el-input>
                      </el-form-item>
                    </el-row>
                  </el-tab-pane>
                  <el-tab-pane label="H5页面" name="tab_h5page">
                    <el-row>
                      <el-form-item label="H5页面：" class="yyzz_upload">
                        <el-input v-model="address_h5" placeholder="H5链接地址"></el-input>
                      </el-form-item>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>
              </el-row>
              <el-row>
                <el-button @click="savelbtinfo">保存轮播图</el-button>
              </el-row>
            </el-form>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="快捷入口配置">
        <el-card class="box-card leftpanel">
          <div slot="header" class="clearfix">
            <span>快捷入口信息</span>
            <el-button style="float: right; padding: 3px 20px" type="text" v-on:click="querykjrk">查询快捷入口</el-button>
            <el-button style="float: right; padding: 3px 0" type="text" v-on:click="addkjrk">添加快捷入口</el-button>
          </div>
          <div>
            <el-row class="querypanel">
              <el-table
                stripe
                :data="kjrkdata"
                ref="multipleTable">
                <el-table-column
                  label="快捷入口图">
                  <template slot-scope="scope">
                    <div v-if="scope.row.scurl.Valid">
                      <img :src="scope.row.scurl.String" class="avatarimg1">
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="scname.String"
                  label="入口名称">
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="80px"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="分配指向" placement="top-start">
                      <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="editkjrk(scope.$index, kjrkdata)"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除该快捷入口" placement="top-start">
                      <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="delkjrk(scope.$index, kjrkdata)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
            <el-dialog title="资料信息" :visible.sync="vis_addshortcutpanel">
              <div class="showpcinfo">
                <el-row>
                  <el-col :span="12">
                    <el-form  label-width="150px">
                      <el-form-item label="显示次序">
                        <el-select v-model="shortcut" filterable placeholder="请选择显示次序">
                          <el-option
                            v-for="item in shortcutlist"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="上传快捷入口图标" class="yyzz_upload">
                        <el-upload
                          class="avatar-uploader"
                          drag
                          action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                          :data="upshortcutparams"
                          multiple
                          :on-success="OnShortCutResourceSuccess"
                          :on-error="OnShortCutResourceError"
                          :before-upload="BeforeShortCutResourceUpload">
                        </el-upload>
                      </el-form-item>
                    </el-form>
                  </el-col>
                  <el-col :span="12">
                    <el-form   label-width="120px" label-position="left">
                      <el-form-item label="链接产品分类:" >
                        <el-table
                          stripe
                          :data="goodstypedata"
                          highlight-current-row
                          @current-change="typeselectchange"
                        >
                          <el-table-column
                            prop="name.String"
                            label="分类名称">
                          </el-table-column>
                        </el-table>
                      </el-form-item>
                    </el-form>
                  </el-col>
                  <el-col :span="24">
                    <el-button style="margin-top: 10px" @click="addnewshortcut">添加快捷入口</el-button>
                  </el-col>
                </el-row>
              </div>
            </el-dialog>
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="专题/活动配置">
        <el-row class="querypanel">
          <el-col :span="24">
            <div>
              <el-button style="margin-top: 10px" @click="addnewlzt">添加新专题</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            stripe
            :data="lztdata"
            ref="multipleTable">
            <el-table-column
              prop="title"
              width = "200px"
              label="标题名称">
            </el-table-column>
            <el-table-column
              prop="subtitle"
              label="子标题">
            </el-table-column>
            <el-table-column
              width = "300px"
              prop="imgurl"
              label="缩略图地址">
            </el-table-column>
            <el-table-column
              label="操作"
              width="120px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="移除该专题" placement="top-start">
                  <i class="fa fa-trash-o fa-lg curpointer" v-on:click="removelzt(scope.$index, lztdata)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-dialog title="添加专题分类" :visible.sync="vislztpanel">
          <div class="showpcinfo">
            <el-form  label-width="150px">
              <el-row class="querypanel">
                <el-col :span="12">
                  <el-form   label-width="120px"  label-position="left">
                    <el-form-item label="是否放置首页:">
                      <el-select v-model="iffzsyinfo" filterable placeholder="请选择是否放置于首页">
                        <el-option
                          v-for="item in iffzsy"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="12">
                  <el-form   label-width="120px" label-position="left">
                    <el-form-item label="放置序号:">
                      <el-input v-model="fzindex" placeholder="放置序号"></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="24">
                  <el-form   label-width="120px" label-position="left">
                    <el-form-item label="标题:">
                      <el-input v-model="zttitle" placeholder="请输入标题"></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="24">
                  <el-form   label-width="120px" label-position="left">
                    <el-form-item label="子标题:" >
                      <el-input v-model="ztsubtitle" placeholder="请输入子标题"></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="24">
                  <el-form   label-width="120px" label-position="left">
                    <el-form-item label="简介:" >
                      <el-input v-model="ztdes" placeholder="请输入简要描述"></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="24">
                  <el-form   label-width="120px" label-position="left">
                    <el-form-item label="专题图片:" >
                      <el-upload
                        class="avatar-uploader"
                        drag
                        action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                        :data="ztparams"
                        :on-success="OnUpFileZTSuccess">
                      </el-upload>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="24">
                  <el-form   label-width="120px" label-position="left">
                    <el-form-item label="链接产品分类:" >
                      <el-table
                        stripe
                        :data="goodstypedata"
                        highlight-current-row
                        @current-change="typeselectchange"
                        >
                        <el-table-column
                          prop="name.String"
                          label="分类名称">
                        </el-table-column>
                      </el-table>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              <el-row class="querypanel">
                <el-button @click="addztcontext">添加专题信息</el-button>
              </el-row>
            </el-form>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="推荐商品配置">
        <el-row class="querypanel">
          <el-col :span="12">
            <el-button  @click="addtjsp">添加推荐商品</el-button>
            <el-button  @click="querytjsp">查询推荐商品</el-button>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            stripe
            :data="tjspdata"
            ref="multipleTable">
            <el-table-column
              prop="name.String"
              label="推荐商品名称">
            </el-table-column>
            <el-table-column
              prop="recindex.Int64"
              label="推荐序号">
            </el-table-column>
            <el-table-column
              label="操作"
              width="80px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑推荐商品" placement="top-start">
                  <i class="fa fa-eye fa-lg opicon curpointer" v-on:click="edittjgoods(scope.$index, tjspdata)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="修改次序" placement="top-start">
                  <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="changeindex(scope.$index, tjspdata)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除推荐商品" placement="top-start">
                  <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="deltjgoods(scope.$index, tjspdata)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-dialog title="资料信息" :visible.sync="vis_addtjgoodspanel" @open="showtjgoodsdialog" ref="tjgoodsdialog">
          <el-row class="querypanel">
            <el-col :span="12">
              <el-form  label-width="150px">
                <el-form-item label="是否推荐">
                  <el-select v-model="ifrecinfo" filterable placeholder="请选择是否推荐">
                    <el-option
                      v-for="item in ifrecdata"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form  label-width="150px">
                <el-form-item label="推荐序号">
                  <el-input v-model="tjindex" placeholder="请输入推荐序号"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="24">
              <div class="tablepanel">
                <el-table
                  fit
                  ref="mytjgoodstbt1"
                  :data="cusgoodsdata"
                  >
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    min-width="30px"
                    prop="goodsindex.Int64"
                    label="推荐次序"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="name.String"
                    label="产品名称">
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
          <div class="showpcinfo" style="margin-top: 15px">
            <el-button  @click="addtjgood">保存推荐商品</el-button>
          </div>

        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="推荐课程配置">
        <el-row class="querypanel">
          <el-col :span="12">
            <el-button @click="querytjcourse">查询推荐课程</el-button>
            <el-button  @click="addtjcourse">添加推荐课程</el-button>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            stripe
            :data="custjcoursedata"
            ref="multipleTable">
            <el-table-column
              prop="id.Int64"
              label="ID">
            </el-table-column>
            <el-table-column
              prop="ctitle.String"
              label="标题">
            </el-table-column>
            <el-table-column
              label="课程缩略图">
              <template slot-scope="scope">
                <div v-if="scope.row.cimgurl.Valid">
                  <img :src="scope.row.cimgurl.String" class="avatarimg1">
                </div>
                <div v-else>
                  {{scope.row.cimgurl.String}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="recindex.Int64"
              label="推荐次序">
            </el-table-column>
            <el-table-column
              prop="addtime.String"
              label="添加时间">
            </el-table-column>
            <el-table-column
              label="操作"
              width="80px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑该推荐课程" placement="top-start">
                  <i class="fa fa-eye fa-lg opicon curpointer" v-on:click="edittjcourse(scope.$index, custjcoursedata)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除该推荐课程" placement="top-start">
                  <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="deltjcourse(scope.$index, custjcoursedata)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-dialog title="资料信息" :visible.sync="vis_addtjcoursepanel">
          <el-row class="querypanel">
            <el-col :span="12">
              <el-form  label-width="150px">
                <el-form-item label="是否推荐">
                  <el-select v-model="ifrecinfo" filterable placeholder="请选择是否推荐">
                    <el-option
                      v-for="item in ifrecdata"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form  label-width="150px">
                <el-form-item label="推荐序号">
                  <el-input v-model="tjindex" placeholder="请输入推荐序号"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="24">
              <div class="tablepanel">
                <el-table
                  fit
                  ref="mytjcoursetbt1"
                  :data="cuscoursedata"
                >
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    min-width="30px"
                    prop="id.Int64"
                    label="ID"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="ctitle.String"
                    label="课程名称">
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
          <div class="showpcinfo" style="margin-top: 15px">
            <el-button  @click="savetjcourse">保存推荐商品</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="推荐分类配置">
        <el-row class="querypanel">
          <el-col :span="12">
            <el-button @click="queryfxtype">查询分类</el-button>
            <el-button  @click="addfxtype">添加分类</el-button>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            stripe
            :data="custjtypedata"
            ref="multipleTable">
            <el-table-column
              prop="typename.String"
              label="分类名称">
            </el-table-column>
            <el-table-column
              prop="typedes.String"
              label="分类子标题">
            </el-table-column>
            <el-table-column
              prop="tjindex"
              label="显示次序">
            </el-table-column>
            <el-table-column
              prop="linkurl.String"
              label="链接地址">
            </el-table-column>
            <el-table-column
              label="分类图片">
              <template slot-scope="scope">
                <div v-if="scope.row.typeurl.Valid">
                  <img :src="scope.row.typeurl.String" class="avatarimg2">
                </div>
                <div v-else>
                  {scope.row.typeurl.String}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="80px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑该分类" placement="top-start">
                  <i class="fa fa-eye fa-lg opicon curpointer" v-on:click="edittjtype(scope.$index, custjtypedata)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除该分类" placement="top-start">
                  <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="deltjtype(scope.$index, custjtypedata)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-dialog title="资料信息" :visible.sync="vis_addtypepanel">
          <div >
            <el-form  label-width="120px">
              <el-row >
                <el-row>
                <el-col :span="12">
                  <el-form-item label="上传分类图片：" class="yyzz_upload">
                    <el-upload
                      class="avatar-uploader"
                      drag
                      action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                      :data="uplbtparams"
                      multiple
                      :on-success="OnTypeImgResourceSuccess"
                      :on-error="OnLCLBTResourceError"
                      :before-upload="BeforeLCLBTResourceUpload">
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-collapse v-model="scactive" accordion>
                    <el-collapse-item title="上传说明" name="1">
                      <div>1、您可以上传任何类型的资料。</div>
                      <div>2、上传前一定要看好上传的路径！</div>
                      <div>3、上传时，上传文件下方会有上传进度。</div>
                    </el-collapse-item>
                  </el-collapse>
                </el-col>
                  <el-col>
                    <el-form-item label="分类图片地址：" class="yyzz_upload">
                      <el-input v-model="address_type" placeholder="视频地址"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                <el-col :span="12">
                  <el-form-item label="上传分类内图：" class="yyzz_upload">
                    <el-upload
                      class="avatar-uploader"
                      drag
                      action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                      :data="uplbtparams"
                      multiple
                      :on-success="OnTypeImg1ResourceSuccess"
                      :on-error="OnLCLBTResourceError"
                      :before-upload="BeforeLCLBTResourceUpload">
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-collapse v-model="scactive" accordion>
                    <el-collapse-item title="上传说明" name="1">
                      <div>1、您可以上传任何类型的资料。</div>
                      <div>2、上传前一定要看好上传的路径！</div>
                      <div>3、上传时，上传文件下方会有上传进度。</div>
                    </el-collapse-item>
                  </el-collapse>
                </el-col>
                  <el-col>
                    <el-form-item label="分类内图地址：" class="yyzz_upload">
                      <el-input v-model="address_typen" placeholder="视频地址"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-col>
                  <el-form-item label="分类名称：" class="yyzz_upload">
                    <el-input v-model="lc_typename" placeholder="请在此处填写分类名称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="描述：" class="yyzz_upload">
                    <el-input v-model="lc_typedes" placeholder="请用简短的话描述分类"></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="显示次序：" class="yyzz_upload">
                    <el-input v-model="lc_tjindex" placeholder="显示次序"></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="链接分类名称：" class="yyzz_upload">
                    <el-input v-model="lc_linkname" disabled placeholder="显示次序"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-form-item label="链接产品分类:" >
                  <el-table
                    stripe
                    ref="linktypetb"
                    :data="goodstypedata"
                    highlight-current-row
                    @current-change="typetjselectchange"
                  >
                    <el-table-column
                      prop="name.String"
                      label="分类名称">
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-row>
              <el-row>
                <el-button @click="savelctypeinfo">保存推荐分类</el-button>
              </el-row>
            </el-form>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="首页视频配置">
        <el-row class="querypanel">
          <el-col :span="12">
            <el-button  @click="readvideoadd">读取当前视频地址</el-button>
            <el-button  @click="savevideoadd">保存当前地址</el-button>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-form>
            <el-col :span="12">
              <el-form-item label="上传宣传视频：" class="yyzz_upload">
                <el-upload
                  class="avatar-uploader"
                  drag
                  action=""
                  :on-success="VideoUploadSuccess"
                  :headers="uploadHeaders"
                  :show-file-list="true"
                  :http-request="VideoUploadRequest"
                  :limit="files">
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="视频地址：" class="yyzz_upload">
                <el-input v-model="address_video_mainpage" placeholder="视频地址"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="联系我们配置">
        <el-row class="querypanel">
          <el-col :span="12">
            <el-button  @click="readcontact">读取联系我们</el-button>
            <el-button  @click="savecontact">保存联系我们</el-button>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-col :span="24" style="height: 400px">
            <el-form   label-width="120px" label-position="left">
              <el-form-item label="联系我们:">
                <quill-editor
                  v-model="contactus"
                  ref="myQuillEditor"
                  :options="editorOption"
                  @change="onEditorChange($event)"
                >
                </quill-editor>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :title="selectuppathtitle" :visible.sync="visupfilepanel">
      <el-row >
        <el-col :span="12">
          <el-form  label-width="120px">
            <el-form-item label="上传资料" class="yyzz_upload">
              <el-upload
                class="avatar-uploader"
                drag
                action=""
                :on-success="fnUploadSuccess"
                :headers="uploadHeaders"
                :show-file-list="true"
                :http-request="fnUploadRequest"
                :limit="files">
              </el-upload>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item title="上传说明" name="1">
              <div>1、您可以上传任何类型的资料。</div>
              <div>2、上传前一定要看好上传的路径！</div>
              <div>3、上传时，上传文件下方会有上传进度。</div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
import ElTabPane from '../../../node_modules/element-ui/packages/tabs/src/tab-pane'
import ElFormItem from '../../../node_modules/element-ui/packages/form/src/form-item'
import * as Quill from 'quill'
import Utils from '../../util/utils'
import Video from '../../util/video'
import {quillRedefine} from 'vue-quill-editor-upload'
import {quillEditor} from 'vue-quill-editor'
var OSS = require('ali-oss')
Quill.register(Video, true)
Vue.prototype.$http = axios
var that
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],
  [{'header': 1}, {'header': 2}],
  [{'list': 'ordered'}, {'list': 'bullet'}],
  [{ script: 'sub' }, { script: 'super' }],
  [{'indent': '-1'}, {'indent': '+1'}],
  [{'direction': 'rtl'}],
  [{'size': ['small', false, 'large', 'huge']}],
  [{'header': [1, 2, 3, 4, 5, 6, false]}],
  [{'color': []}, {'background': []}],
  [{'font': []}],
  [{'align': []}],
  ['link', 'image', 'video'],
  ['clean']
]
export default {
  components: {
    ElFormItem,
    ElTabPane,
    quillEditor,
    quillRedefine
  },
  name: 'LayoutControl',
  data () {
    return {
      lbt_link: 'tab_video',
      brandpos: '1',
      address_lbt: '',
      address_video: '',
      select_type: '',
      contactus: '',
      address_video_mainpage: '',
      selectuppathtitle: '',
      radiovalue: '1',
      activeName: 0,
      uploadHeaders: {
        authorization: ''
      },
      lbttjindex: 0,
      address_h5: '',
      address_type: '',
      address_typen: '',
      files: 100,
      address_type_img: '',
      visupfilepanel: false,
      editorOption: {},
      ifnewtjtype: false,
      ifnewtjgoods: false,
      ifnewbrand: false,
      edittjtypedata: '',
      edittjgoodsdata: '',
      editbranddata: '',
      lc_typename: '',
      lc_typedes: '',
      lc_linkname: '',
      lc_tjindex: 0,
      brandposlist: [{
        value: '0',
        label: '所有类型'
      }, {
        value: '1',
        label: '顶部'
      }, {
        value: '2',
        label: '中间'
      }, {
        value: '3',
        label: '底部'
      }],
      shortcutlist: [{
        value: '1',
        label: '1号位置'
      }, {
        value: '2',
        label: '2号位置'
      }, {
        value: '3',
        label: '3号位置'
      }, {
        value: '4',
        label: '4号位置'
      }, {
        value: '5',
        label: '5号位置'
      }, {
        value: '6',
        label: '6号位置'
      }, {
        value: '7',
        label: '7号位置'
      }, {
        value: '8',
        label: '8号位置'
      }],
      ifrecdata: [{
        value: '1',
        label: '推荐'
      }, {
        value: '2',
        label: '不推荐'
      }],
      iffzsyinfo: '1',
      iffzsy: [{
        value: '1',
        label: '放置'
      }, {
        value: '2',
        label: '不放置'
      }],
      tjindex: '',
      scactive: '1',
      shortcut: '',
      showlbtlink: false,
      vislztpanel: false,
      branddata: [],
      tjspdata: [],
      kjrkdata: [],
      lztdata: [],
      goodstypedata: [],
      cusgoodsdata: [],
      ifrecinfo: '1',
      vis_addbrandpanel: false,
      vis_addshortcutpanel: false,
      vis_addtjgoodspanel: false,
      vis_addtypepanel: false,
      uplbtparams: '',
      upshortcutparams: '',
      ztparams: '',
      ztimg: '',
      zttitle: '',
      ztsubtitle: '',
      selectpath: '',
      ztdes: '',
      selecttype: '',
      fzindex: '',
      shortcutpath: '',
      upvideos: '',
      custjtypedata: [],
      custjcoursedata: [], /// 推荐分类数据
      vis_addtjcoursepanel: false, /// 是否显示分类面板
      ifnewcoursetype: false,
      cuscoursedata: []
    }
  },
  created: function () {
    this.editorOption =
      {
        uploadConfig: {
          methods: 'POST',
          res: (respnse) => {
            console.log(respnse)
            return respnse.info
          }
        },
        methods: 'POST',
        size: 5100,
        accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',
        // input点击事件  formData是提交的表单实体
        change: (formData) => {
        },
        // 设置请求头 xhr: 异步请求， formData: 表单对象
        header: (xhr, formData) => {
          // xhr.setRequestHeader('myHeader','myValue');
          // formData.append('token', '1234')
        },
        // start: function (){}
        start: () => {
        },
        end: () => {
        },
        success: () => {
          console.log('上传成功')
        },
        error: () => {
        },
        placeholder: '请在此输入内容',
        theme: 'snow',
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              'image': function (value) {
                that.visupfilepanel = true
                that.selectuppathtitle = '上传图片'
                that.upfiletype = 'image'
              },
              'video': function (value) {
                that.visupfilepanel = true
                that.selectuppathtitle = '上传视频'
                that.upfiletype = 'video'
              }
            }
          }
        }
      }
  },
  mounted: function () {
    that = this
    var v = getCookie('cusid')
    this.khid = v
    that.selectpath = 'others/'
    this.uplbtparams = {
      bucketname: 'wyzb1',
      bucketpath: 'brands/admin'
    }
    this.upshortcutparams = {
      bucketname: 'wyzb1',
      bucketpath: 'shortcut/admin'
    }
    this.ztparams = {
      bucketname: 'wyzb1',
      bucketpath: 'zt/admin'
    }
    this.upvideos = {
      bucketname: 'wyzb1',
      bucketpath: 'videos'
    }
    var qstr = 'cusid =' + this.khid
    that.$http({
      url: 'https://api.sqnetsoft.cn/goods/qginfo',
      method: 'post',
      data: {
        whereinfo: {String: qstr, Valid: true},
        sorinfo: {String: ' order by goodsindex', Valid: true}
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        console.log(res)
        console.log(JSON.parse(res.data.data))
        if (res.data.success) {
          that.cusgoodsdata = JSON.parse(res.data.data)
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
    var qstr1 = 'cusid = ' + this.khid + ' and parentid >0'
    that.$http({
      url: 'https://api.sqnetsoft.cn/goods/qgt',
      method: 'post',
      data: {
        whereinfo: {String: qstr1, Valid: true}
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        console.log('*****************初始化分类数据******************')
        if (res.data.success) {
          console.log('已完成分类数据初始化')
          that.goodstypedata = JSON.parse(res.data.data)
        } else {
          console.log('获取分类数据失败')
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
    that.$options.methods.querylzt()
  },
  methods: {
    addtjcourse () {
      this.vis_addtjcoursepanel = true
      this.ifnewcoursetype = true
      this.ifrecinfo = '1'
      this.tjindex = 0
      this.$refs.mytjcoursetbt1.clearSelection()
    },
    /// 查询推荐课程
    querytjcourse () {
      var qstr = 'cusid =' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/getgr',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: 'order by recindex,addtime', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.custjcoursedata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    getcoursedata () {
      /// 查询上架课程
      var qstr1 = 'cusid = ' + that.khid + ' and state=1'
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/qci',
        method: 'post',
        data: {
          whereinfo: {String: qstr1, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log('*****************初始化分类数据******************')
          if (res.data.success) {
            console.log('已完成课程信息')
            that.cuscoursedata = JSON.parse(res.data.data)
          } else {
            console.log('获取分类数据失败')
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    savetjcourse () {
      var insertdata = []
      console.log('保存推荐课程')
      if (this.$refs.mytjcoursetbt1.selection.length > 0) {
        console.log(this.$refs.mytjcoursetbt1.selection)
        console.log(this.edittjcoursedata)
        if (this.ifnewcoursetype) {
          for (var index in this.$refs.mytjcoursetbt1.selection) {
            var tmpdata = {
              goodsid: parseInt(this.$refs.mytjcoursetbt1.selection[index].id.Int64),
              ifrec: parseInt(that.ifrecinfo),
              recindex: parseInt(that.tjindex),
              cusid: parseInt(that.khid)
            }
            insertdata.push(tmpdata)
          }
        } else {
          var tmpdata1 = {
            id: {Int64: parseInt(this.edittjcoursedata.id.Int64), Valid: true},
            goodsid: parseInt(this.$refs.mytjcoursetbt1.selection[0].id.Int64),
            ifrec: parseInt(that.ifrecinfo),
            recindex: parseInt(that.tjindex),
            cusid: parseInt(that.khid)
          }
          insertdata.push(tmpdata1)
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/layout/paaulgr',
          method: 'post',
          data: insertdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '保存完毕'
              })
              that.$options.methods.querytjcourse()
              that.vis_addtjcoursepanel = false
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        that.$message({
          type: 'info',
          message: '课程为选择'
        })
      }
    },
    edittjcourse (index, data) {
      var curselectdata = data[index]
      this.edittjcoursedata = curselectdata
      this.ifnewcoursetype = false
      console.log(curselectdata)
      this.vis_addtjcoursepanel = true
      this.ifrecinfo = curselectdata.ifrec.Int64.toString()
      this.tjindex = curselectdata.recindex.Int64
      var dataindex = that.cuscoursedata.findIndex(d => d.id.Int64 === curselectdata.goodsid.Int64)
      console.log(that.cuscoursedata[dataindex])
      setTimeout(() => {
        this.$refs.mytjcoursetbt1.clearSelection()
        if (that.cuscoursedata[dataindex]) {
          this.$refs.mytjcoursetbt1.toggleRowSelection(that.cuscoursedata[dataindex])
        }
      }, 0)
    },
    deltjcourse (index, data) {
      var curselectdata = data[index]
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/dellgr',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
            // 移除该条数据
            data.splice(dataindex, 1)
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    readvideoadd: function () {
      var qstr1 = 'id = 1'
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/glvi',
        method: 'post',
        data: {
          whereinfo: {String: qstr1, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log('*****************初始化分类数据******************')
          if (res.data.success) {
            console.log('已完成分类数据初始化')
            var tmpdata = JSON.parse(res.data.data)
            that.address_video_mainpage = tmpdata[0].videourl
          } else {
            console.log('获取分类数据失败')
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    savevideoadd: function () {
      var idata = {
        fieldparams: {String: "videourl='" + this.address_video_mainpage + "'", Valid: true},
        whereinfo: {String: 'id=1', Valid: true}
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/ulvi',
        method: 'post',
        data: idata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '更新完毕'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    readcontact: function () {
      var qstr1 = 'id = 1'
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/glai',
        method: 'post',
        data: {
          whereinfo: {String: qstr1, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log('*****************初始化分类数据******************')
          if (res.data.success) {
            var tmpdata = JSON.parse(res.data.data)
            that.contactus = tmpdata[0].aboutinfo
          } else {
            console.log('获取分类数据失败')
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    savecontact: function () {
      var idata = {
        fieldparams: {String: "aboutinfo='" + this.contactus + "'", Valid: true},
        whereinfo: {String: 'id=1', Valid: true}
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/ulai',
        method: 'post',
        data: idata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '更新完毕'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    onEditorChange ({editor, html, text}) {
      console.log('---内容改变事件---')
      console.log(html)
    },
    linkchange () {
      if (this.radiovalue === '1') {
        this.showlbtlink = false
      } else if (this.radiovalue === '2') {
        this.showlbtlink = true
      }
    },
    OnUpFileZTSuccess (res, file, fileList) {
      if (res.success) {
        this.ztimg = res.data[0].osspath
      }
    },
    OnTypeImgResourceSuccess (res, file, fileList) {
      this.address_type = res.data[0].osspath
    },
    OnTypeNImgResourceSuccess (res, file, fileList) {
      this.address_type_img = res.data[0].osspath
    },
    OnTypeImg1ResourceSuccess (res, file, fileList) {
      this.address_typen = res.data[0].osspath
    },
    OnLCLBTResourceSuccess (res, file, fileList) {
      if (res.success) {
        this.address_lbt = res.data[0].osspath
      }
    },
    OnVideoResourceSuccess (res, file, fileList) {
      if (res.success) {
        this.address_video = res.data[0].osspath
      }
    },
    OnLCLBTResourceError () {},
    BeforeLCLBTResourceUpload () {},
    OnShortCutResourceSuccess (res, file, fileList) {
      if (res.success) {
        this.shortcutpath = res.data[0].osspath
      }
    },
    OnShortCutResourceError () {},
    BeforeShortCutResourceUpload () {},
    /// 保存轮播图信息
    savelbtinfo () {
      var lbtdata
      if (this.ifnewbrand) {
        if (this.radiovalue === '1') {
          lbtdata = {
            adurl: {String: this.address_lbt, Valid: true},
            pos: {String: that.brandpos, Valid: true},
            appid: parseInt(1),
            linktype: parseInt(0),
            tjindex: parseInt(this.lbttjindex),
            cusid: parseInt(that.khid)
          }
        } else if (this.radiovalue === '2') {
          if (this.lbt_link === 'tab_video') {
            lbtdata = {
              adurl: {String: this.address_lbt, Valid: true},
              pos: {String: that.brandpos, Valid: true},
              appid: parseInt(1),
              linktype: parseInt(1),
              hurl: {String: this.address_video, Valid: true},
              tjindex: parseInt(this.lbttjindex),
              cusid: parseInt(that.khid)
            }
          } else if (this.lbt_link === 'tab_goodstype') {
            lbtdata = {
              adurl: {String: this.address_lbt, Valid: true},
              pos: {String: that.brandpos, Valid: true},
              hurl: {String: this.address_type_img, Valid: true},
              appid: parseInt(1),
              linktype: parseInt(2),
              goodstypeid: parseInt(this.selecttype.id.Int64),
              tjindex: parseInt(this.lbttjindex),
              cusid: parseInt(that.khid)
            }
          } else {
            lbtdata = {
              adurl: {String: this.address_lbt, Valid: true},
              pos: {String: that.brandpos, Valid: true},
              appid: parseInt(1),
              linktype: parseInt(3),
              hurl: {String: this.address_h5, Valid: true},
              tjindex: parseInt(this.lbttjindex),
              cusid: parseInt(that.khid)
            }
          }
        }
      } else {
        if (this.radiovalue === '1') {
          lbtdata = {
            id: {Int64: parseInt(this.editbranddata.id.Int64), Valid: true},
            adurl: {String: this.address_lbt, Valid: true},
            pos: {String: that.brandpos, Valid: true},
            appid: parseInt(1),
            linktype: parseInt(0),
            tjindex: parseInt(this.lbttjindex),
            cusid: parseInt(that.khid)
          }
        } else if (this.radiovalue === '2') {
          if (this.lbt_link === 'tab_video') {
            lbtdata = {
              id: {Int64: parseInt(this.editbranddata.id.Int64), Valid: true},
              adurl: {String: this.address_lbt, Valid: true},
              pos: {String: that.brandpos, Valid: true},
              appid: parseInt(1),
              linktype: parseInt(1),
              tjindex: parseInt(this.lbttjindex),
              hurl: {String: this.address_video, Valid: true},
              cusid: parseInt(that.khid)
            }
          } else if (this.lbt_link === 'tab_goodstype') {
            lbtdata = {
              id: {Int64: parseInt(this.editbranddata.id.Int64), Valid: true},
              adurl: {String: this.address_lbt, Valid: true},
              pos: {String: that.brandpos, Valid: true},
              hurl: {String: this.address_type_img, Valid: true},
              appid: parseInt(1),
              linktype: parseInt(2),
              tjindex: parseInt(this.lbttjindex),
              goodstypeid: parseInt(this.selecttype.id.Int64),
              cusid: parseInt(that.khid)
            }
          } else {
            lbtdata = {
              id: {Int64: parseInt(this.editbranddata.id.Int64), Valid: true},
              adurl: {String: this.address_lbt, Valid: true},
              pos: {String: that.brandpos, Valid: true},
              appid: parseInt(1),
              linktype: parseInt(3),
              tjindex: parseInt(this.lbttjindex),
              hurl: {String: this.address_h5, Valid: true},
              cusid: parseInt(that.khid)
            }
          }
        }
      }
      console.log(lbtdata)
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/aaulbi',
        method: 'post',
        data: lbtdata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '添加完毕'
            })
            var qstr = 'cusid =' + that.khid
            that.$http({
              url: 'https://api.sqnetsoft.cn/layout/getlbi',
              method: 'post',
              data: {
                whereinfo: {String: qstr, Valid: true},
                sorinfo: {String: ' order by tjindex', Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  console.log(JSON.parse(res.data.data))
                  that.branddata = JSON.parse(res.data.data)
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    /// 查询推荐分类
    queryfxtype () {
      var qstr = 'cusid =' + this.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/getti',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: 'order by tjindex', Valid: true},
          limit: {String: 'limit 50', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.custjtypedata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    changeindex (index, data) {
      var seldata = data[index]
      console.log(seldata)
      this.$prompt('请输入显示次序（数字）', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        var goodsobjtmp = {
          id: {Int64: seldata.id.Int64, Valid: true},
          goodsid: parseInt(seldata.goodsid.Int64),
          ifrec: parseInt(seldata.ifrec.Int64),
          recindex: parseInt(value),
          cusid: parseInt(this.khid)
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/layout/aaulgr',
          method: 'post',
          data: goodsobjtmp,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$options.methods.querytjspex()
              that.$message({
                type: 'success',
                message: '已更新次序'
              })
            } else {

            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消次序变更'
        })
      })
    },
    /// 编辑推荐分类
    edittjtype (index, data) {
      var curselectdata = data[index]
      this.edittjtypedata = curselectdata
      this.ifnewtjtype = false
      console.log(curselectdata)
      this.vis_addtypepanel = true
      this.address_type = curselectdata.linkurl.String
      this.address_typen = curselectdata.typeurl.String
      this.lc_typename = curselectdata.typename.String
      this.lc_typedes = curselectdata.typedes.String
      this.lc_tjindex = curselectdata.tjindex
      console.log(that.goodstypedata)
      var dataindex = that.goodstypedata.findIndex(d => d.id.Int64 === curselectdata.goodstypeid)
      console.log(that.goodstypedata[dataindex])
      this.lc_linkname = that.goodstypedata[dataindex].name.String
      this.selecttype = that.goodstypedata[dataindex]
      console.log(this)
      setTimeout(() => {
        this.$refs.lbtlinktype.setCurrentRow(that.goodstypedata[dataindex])
      }, 0)
    },
    /// 保存推荐分类
    savelctypeinfo () {
      var insertdata = ''
      if (this.ifnewtjtype) {
        insertdata = {
          typeurl: {String: this.address_type, Valid: true},
          linkurl: {String: this.address_typen, Valid: true},
          typename: {String: this.lc_typename, Valid: true},
          typedes: {String: this.lc_typedes, Valid: true},
          goodstypeid: parseInt(this.selecttype.id.Int64),
          tjindex: parseInt(this.lc_tjindex),
          cusid: parseInt(this.khid)
        }
      } else {
        insertdata = {
          id: {Int64: parseInt(this.edittjtypedata.id.Int64), Valid: true},
          typeurl: {String: this.address_type, Valid: true},
          linkurl: {String: this.address_typen, Valid: true},
          typename: {String: this.lc_typename, Valid: true},
          typedes: {String: this.lc_typedes, Valid: true},
          goodstypeid: parseInt(this.selecttype.id.Int64),
          tjindex: parseInt(this.lc_tjindex),
          cusid: parseInt(this.khid)
        }
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/aauti',
        method: 'post',
        data: insertdata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '添加完毕'
            })
            var qstr = 'cusid =' + that.khid
            that.$http({
              url: 'https://api.sqnetsoft.cn/layout/getti',
              method: 'post',
              data: {
                whereinfo: {String: qstr, Valid: true},
                sorinfo: {String: 'order by tjindex', Valid: true},
                limit: {String: 'limit 50', Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                console.log(res)
                console.log(JSON.parse(res.data.data))
                if (res.data.success) {
                  that.custjtypedata = JSON.parse(res.data.data)
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    deltjtype (index, data) {
      var curselectdata = data[index]
      var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
      // 移除该条数据
      data.splice(dataindex, 1)
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/delti',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    typetjselectchange (row) {
      this.selecttype = row
      this.lc_linkname = row.name.String
    },
    addfxtype () {
      this.vis_addtypepanel = true
      this.ifnewtjtype = true
      this.address_type = ''
      this.address_typen = ''
      this.lc_typename = ''
      this.lc_typedes = ''
      this.lc_tjindex = ''
      this.lc_linkname = ''
    },
    addnewlzt () {
      this.vislztpanel = true
    },
    editlbt (index, data) {
      var curselectdata = data[index]
      this.ifnewbrand = false
      this.vis_addbrandpanel = true
      this.editbranddata = curselectdata
      console.log(curselectdata)
      this.address_lbt = curselectdata.adurl.String
      this.lbttjindex = curselectdata.tjindex
      if (curselectdata.linktype === 0) {
        this.radiovalue = '1'
        this.showlbtlink = false
      } else if (curselectdata.linktype === 1) {
        this.radiovalue = '2'
        this.showlbtlink = true
        this.lbt_link = 'tab_video'
        this.address_video = curselectdata.hurl.String
      } else if (curselectdata.linktype === 2) {
        this.radiovalue = '2'
        this.showlbtlink = true
        this.lbt_link = 'tab_goodstype'
        var dataindex = that.goodstypedata.findIndex(d => d.id.Int64 === curselectdata.goodstypeid)
        console.log(that.goodstypedata[dataindex])
        this.select_type = that.goodstypedata[dataindex].name.String
        this.selecttype = that.goodstypedata[dataindex]
        this.address_type_img = curselectdata.hurl.String
        console.log(this)
        setTimeout(() => {
          this.$refs.lbtlinktype.setCurrentRow(that.goodstypedata[dataindex])
        }, 0)
      } else if (curselectdata.linktype === 3) {
        this.radiovalue = '2'
        this.showlbtlink = true
        this.address_h5 = curselectdata.hurl.String
        this.lbt_link = 'tab_h5page'
      }
    },
    dellbt (index, data) {
      var curselectdata = data[index]
      var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
      // 移除该条数据
      data.splice(dataindex, 1)
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/dellbi',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    addbrand () {
      this.ifnewbrand = true
      this.vis_addbrandpanel = true
      this.radiovalue = '1'
      this.address_lbt = ''
      this.address_video = ''
      this.address_type_img = ''
      this.address_h5 = ''
    },
    addbrandinfo () {
    },
    querybrand () {
      that = this
      if (that.khid === null) {
        that.$message({
          type: 'info',
          message: 'Cookie已失效，请重新登录!'
        })
        that.$router.push({path: '/'})
      } else {
        var qstr = 'cusid =' + this.khid
        that.$http({
          url: 'https://api.sqnetsoft.cn/layout/getlbi',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true},
            sorinfo: {String: ' order by tjindex', Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              console.log(JSON.parse(res.data.data))
              that.branddata = JSON.parse(res.data.data)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    querytjspex: function () {
      var qstr = 'cusid =' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/getgr',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: ' order by recindex', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.tjspdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    /// 查询推荐商品
    querytjsp () {
      that = this
      if (that.khid === null) {
        that.$message({
          type: 'info',
          message: 'Cookie已失效，请重新登录!'
        })
        that.$router.push({path: '/'})
      } else {
        var qstr = 'cusid =' + that.khid
        that.$http({
          url: 'https://api.sqnetsoft.cn/layout/getgr',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true},
            sorinfo: {String: ' order by recindex', Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              console.log(JSON.parse(res.data.data))
              that.tjspdata = JSON.parse(res.data.data)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    /// 添加推荐商品
    addtjsp () {
      this.vis_addtjgoodspanel = true
      this.ifnewtjgoods = true
      setTimeout(() => {
        this.$refs.mytjgoodstbt1.clearSelection()
      }, 0)
    },
    querykjrk () {
      that = this
      if (that.khid === null) {
        that.$message({
          type: 'info',
          message: 'Cookie已失效，请重新登录!'
        })
        that.$router.push({path: '/'})
      } else {
        var qstr = 'cusid =' + this.khid
        that.$http({
          url: 'https://api.sqnetsoft.cn/layout/getsci',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              console.log(JSON.parse(res.data.data))
              that.kjrkdata = JSON.parse(res.data.data)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    addkjrk () {
      this.vis_addshortcutpanel = true
    },
    /// 保存推荐商品
    addtjgood () {
      console.log()
      var addgood = []
      if (this.ifnewtjgoods) {
        for (var index in this.$refs.mytjgoodstbt1.selection) {
          var tmpdata = {
            goodsid: parseInt(this.$refs.mytjgoodstbt1.selection[index].id.Int64),
            ifrec: parseInt(that.ifrecinfo),
            recindex: parseInt(that.tjindex),
            cusid: parseInt(that.khid)
          }
          addgood.push(tmpdata)
        }
      } else {
        var tmpdata1 = {
          id: {Int64: parseInt(this.edittjgoodsdata.id.Int64), Valid: true},
          goodsid: parseInt(this.$refs.mytjgoodstbt1.selection[0].id.Int64),
          ifrec: parseInt(that.ifrecinfo),
          recindex: parseInt(that.tjindex),
          cusid: parseInt(that.khid)
        }
        addgood.push(tmpdata1)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/paaulgr',
        method: 'post',
        data: addgood,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '添加完毕'
            })
            var qstr = 'cusid =' + that.khid
            that.$http({
              url: 'https://api.sqnetsoft.cn/layout/getgr',
              method: 'post',
              data: {
                whereinfo: {String: qstr, Valid: true},
                sorinfo: {String: ' order by recindex', Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  console.log(JSON.parse(res.data.data))
                  that.tjspdata = JSON.parse(res.data.data)
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    /// 编辑推荐商品
    edittjgoods (index, data) {
      var curselectdata = data[index]
      this.ifnewtjgoods = false
      this.vis_addtjgoodspanel = true
      console.log(curselectdata)
      console.log(this.cusgoodsdata)
      this.ifrecinfo = curselectdata.ifrec.Int64.toString()
      this.tjindex = curselectdata.recindex.Int64
      var dataindex = that.cusgoodsdata.findIndex(d => d.id.Int64 === curselectdata.goodsid.Int64)
      console.log(that.cusgoodsdata[dataindex])
      this.edittjgoodsdata = that.cusgoodsdata[dataindex]
      setTimeout(() => {
        this.$refs.mytjgoodstbt1.clearSelection()
        this.$refs.mytjgoodstbt1.toggleRowSelection(that.cusgoodsdata[dataindex])
      }, 0)
    },
    showtjgoodsdialog () {
      console.log(this)
      console.log(this.$refs.mytjgoodstbt1)
    },
    /// 删除推荐商品
    deltjgoods (index, data) {
      var curselectdata = data[index]
      var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
      // 移除该条数据
      data.splice(dataindex, 1)
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/dellgr',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    delkjrk (index, data) {
      var curselectdata = data[index]
      var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
      // 移除该条数据
      data.splice(dataindex, 1)
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/dellsci',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    editkjrk (index, data) {},
    removelzt (index, data) {
      var selectdata = data[index]
      var dataindex = data.findIndex(d => d.id.Int64 === selectdata.id.Int64)
      // 移除该条数据
      data.splice(dataindex, 1)
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/dlcs',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + selectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    querylzt () {
      var qstr = 'cusid = ' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/glcs',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            var objtmp = JSON.parse(res.data.data)
            console.log(objtmp)
            that.lztdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    addztcontext () {
      console.log(this.iffzsyinfo)
      console.log(this.zttitle)
      console.log(this.ztsubtitle)
      console.log(this.ztdes)
      console.log(this.ztimg)
      if (this.zttitle === '' || this.ztsubtitle === '' || this.ztimg === '' || this.selecttype === '') {
        that.$message({
          type: 'info',
          message: '信息填写不完整'
        })
      } else {
        var indextmp = 0
        if (this.fzindex !== '') {
          indextmp = parseInt(this.fzindex)
        }
        var idata = {
          title: this.zttitle,
          subtitle: this.ztsubtitle,
          context: this.ztdes,
          imgurl: this.ztimg,
          linkurl: this.selecttype.id.Int64.toString(),
          ifrec: parseInt(this.iffzsyinfo),
          recindex: indextmp,
          cusid: parseInt(this.khid)
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/layout/aaulcs',
          method: 'post',
          data: idata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '添加完毕'
              })
              that.$options.methods.querylzt()
              that.vislztpanel = false
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    typeselectchange (row) {
      console.log(row)
      this.selecttype = row
      this.select_type = row.name.String
    },
    addnewshortcut () {
      var data = {
        scurl: {String: that.shortcutpath, Valid: true},
        ascindex: {String: that.shortcut, Valid: true},
        link: {String: this.selecttype.id.Int64.toString(), Valid: true},
        appid: parseInt(1),
        cusid: parseInt(that.khid)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/layout/aaulsci',
        method: 'post',
        data: data,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '添加完毕'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    randomString (num) {
      let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
      let res = ''
      for (let i = 0; i < num; i++) {
        var id = Math.ceil(Math.random() * 35)
        res += chars[id]
      }
      return res
    },
    /**
     * 创建oss客户端对象
     * @returns {*}
     */
    createOssClient () {
      return new Promise((resolve, reject) => {
        let client = new OSS({
          region: 'oss-cn-beijing',
          accessKeyId: 'LTAIK44bzZpLz0As',
          accessKeySecret: 'pWSiczyGrBXhnXIJ7Crj8GxNkkEzM0',
          bucket: 'wyzb1'
        })
        resolve(client)
      })
    },
    async fnUploadRequest (option) {
      var that = this
      let file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        let date = Utils.dateFormat(new Date(), 'yyyyMMdd') // 当前时间
        console.log(date)
        let dateTime = Utils.dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.randomString(4)//  4位随机字符串
        let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        console.log(dateTime)
        console.log(randomStr)
        console.log(extensionName)
        let fileName = that.selectpath + file.name // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.createOssClient().then(client => {
          // 异步上传,返回数据
          resolve({
            fileName: file.name,
            fileUrl: fileName
          })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file, {
            progress: function (p) {
              let e = {}
              e.percent = Math.floor(p * 100)
              // console.log('Progress: ' + p)
              option.onProgress(e)
              that.uppercent = e.percent
              console.log(e.percent)
            }
          }).then((val) => {
            if (val.res.statusCode === 200) {
              option.onSuccess(val)
              return val
            } else {
              option.onError('上传失败')
            }
          }, err => {
            option.onError('上传失败')
            reject(err)
          })
        }).catch(errinfo => {
        })
      })
    },
    async fnUploadSuccess (res, file, fileList) {
      console.log(res)
      if (res.res.status === 200) {
        var uppath = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
        console.log(uppath)
        console.log(this.upfiletype)
        if (this.upfiletype === 'image') {
          this.pagecontext = this.pagecontext + '<p><img src="' + uppath + '"></p>'
        } else {
          this.pagecontext = this.pagecontext + '<video class="videoinfo" id="videoinfo" src="' + uppath + '" controls="controls" loop="loop"> </video>'
        }
        console.log(this.pagecontext)
      }
      // TODO
    },
    async VideoUploadRequest (option) {
      var that = this
      that.selectpath = 'videos/'
      let file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        let date = Utils.dateFormat(new Date(), 'yyyyMMdd') // 当前时间
        console.log(date)
        let dateTime = Utils.dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.randomString(4)//  4位随机字符串
        let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        console.log(dateTime)
        console.log(randomStr)
        console.log(extensionName)
        let fileName = that.selectpath + file.name // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.createOssClient().then(client => {
          // 异步上传,返回数据
          resolve({
            fileName: file.name,
            fileUrl: fileName
          })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file, {
            progress: function (p) {
              let e = {}
              e.percent = Math.floor(p * 100)
              // console.log('Progress: ' + p)
              option.onProgress(e)
              that.uppercent = e.percent
              console.log(e.percent)
            }
          }).then((val) => {
            if (val.res.statusCode === 200) {
              option.onSuccess(val)
              return val
            } else {
              option.onError('上传失败')
            }
          }, err => {
            option.onError('上传失败')
            reject(err)
          })
        }).catch(errinfo => {
        })
      })
    },
    async VideoUploadSuccess (res, file, fileList) {
      console.log(res)
      if (res.res.status === 200) {
        var uppath = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
        this.address_video_mainpage = uppath
      }
      // TODO
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/control/LayoutControl.vue